// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bNv2OJM5q404ji2I {
  width: 1330px;
  margin: 0 auto 0;
  display: flex;
  justify-content: space-between;
}

.bNv2OJM5q404ji2I .LDEs8UZpisEBr9zM {
  height: 280px;
  aspect-ratio: 2/1;
  flex-shrink: 0;
}

.bNv2OJM5q404ji2I .RPvvKGW6mdciHSkb {
  width: 570px;
}

.VCVH1a6uJikw4yGY {
  font-size: 42px;
  color: #303030;
  font-weight: 600;
  margin: 0 0 22px;
  font-family: Montserrat;
  line-height: 106%;
}

.JVVcciaQtwgDC8LT {
  margin: 0 0 80px;
  font-size: 24px;
  font-weight: 200;
  font-style: italic;
  color: #303030;
}

.NiXWl9Y0XE040ADy {
  display: flex;
  align-items: center;
  color: #ffffff;
  background-color: #20336c;
  padding: 12px 25px;
  border-radius: 16px;
  font-size: 24px;
  width: fit-content;
  font-weight: 200;
}

.NiXWl9Y0XE040ADy i {
  margin-right: 13px;
}

.NiXWl9Y0XE040ADy:hover {
  color: #20336c;
  background-color: #ffffff;
  border: 1px solid #20336c;
}

.M_cvgcOOKw4akO1v {
  width: 1180px;
  margin: 0 auto;
  padding-bottom: 96px;
}

.kHu2rouiRMUJK3nH {
  position: relative;
  text-align: center;
  font-family: Montserrat;
  font-weight: 300;
  font-size: 100px;
  color: #000000;
  padding: 90px 0px;
  margin: 0px;
  animation: h_SUPNIcX7wZfhCB 0.6s ease-in 0s 1;
}

@keyframes h_SUPNIcX7wZfhCB {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

.w1MNn99RX4GLps4g {
  opacity: 0;
  animation: VHliPEr9qYEGovga 0.6s ease-in 0.6s 1 forwards;
}

@keyframes VHliPEr9qYEGovga {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.bq9pglCqUhw8iQwH {
  font-family: "Roboto";
  font-size: 22px;
  color: #000000;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 28px;
}

.nHSAOhz0BDYFBogX {
  display: flex;
  flex-wrap: wrap;
  gap: 13px;
}

.F0XXXeX6818sesO4 {
  display: inline-block;
}

.F0XXXeX6818sesO4:hover {
  transform: translateY(-6px);
}

.F0XXXeX6818sesO4:hover .L5R1XVRD0z8h56IG {
  background-color: #c6d4e1;
}

.Oflek4dvgeU9mQTn {
  width: 225px;
  height: 225px;
  border-radius: 38px;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
}
/* 
.stationCard:hover {
  box-shadow: 4px 4px 0 0 #20336c;
  transform: translate(-3px, -3px);
} */

.Oflek4dvgeU9mQTn .LDEs8UZpisEBr9zM {
  height: 155px;
  background-color: gray;
  background-size: cover;
  position: relative;
}

.mbWm5hiqW2MEcNH_ {
  background-color: #c84014;
  font-size: 14px;
  position: absolute;
  top: 10px;
  right: 13px;
  color: white;
  padding: 6px 10px;
  border: 1px solid #ffffff;
  border-radius: 35px;
  font-family: Roboto;
}

.Oflek4dvgeU9mQTn .L5R1XVRD0z8h56IG {
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 16px;
  font-family: "Roboto";
  background-color: #ffffff;
  padding: 0 8px;
  text-align: center;
  line-height: 1.2;
  word-break: break-word;
}

@media screen and (max-width: 1360px) {
  .bNv2OJM5q404ji2I {
    width: 100%;
    margin: 112px 0 85px;
    padding: 0 30px;
    flex-direction: column-reverse;
    align-items: center;
  }

  .bNv2OJM5q404ji2I .LDEs8UZpisEBr9zM {
    height: 176px;
    margin-bottom: 132px;
  }

  .bNv2OJM5q404ji2I .RPvvKGW6mdciHSkb {
    width: 100%;
  }

  .VCVH1a6uJikw4yGY {
    font-size: 20px;
    font-weight: 500;
    margin: 0 0 28px;
    text-align: center;
  }

  .JVVcciaQtwgDC8LT {
    font-size: 14px;
    text-align: center;
  }

  .NiXWl9Y0XE040ADy {
    position: absolute;
    bottom: 106px;
    width: calc(100% - 60px);
    justify-content: center;
    font-size: 16px;
    padding: 17px 0px;
  }
}

@media screen and (max-width: 1240px) {
  .M_cvgcOOKw4akO1v {
    width: 688px;
  }

  .kHu2rouiRMUJK3nH {
    padding: 38px 0px 22px;
    font-size: 36px;
  }

  .bq9pglCqUhw8iQwH {
    font-size: 16px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 18px;
  }

  .nHSAOhz0BDYFBogX {
    width: 688px;
    margin: 0px auto;
  }

  .Oflek4dvgeU9mQTn {
    width: 160px;
    height: 160px;
    border-radius: 30px;
  }

  .Oflek4dvgeU9mQTn .LDEs8UZpisEBr9zM {
    height: 109px;
  }

  .mbWm5hiqW2MEcNH_ {
    font-size: 10px;
    top: 9px;
    right: 10px;
    padding: 4px 6px;
    border-radius: 35px;
  }

  .Oflek4dvgeU9mQTn .L5R1XVRD0z8h56IG {
    height: 50px;
    font-size: 11px;
  }
}

@media screen and (max-width: 768px) {
  .nHSAOhz0BDYFBogX {
    width: 512px;
  }
  .M_cvgcOOKw4akO1v {
    width: 512px;
  }
}

@media screen and (max-width: 520px) {
  .nHSAOhz0BDYFBogX {
    width: 336px;
  }
  .M_cvgcOOKw4akO1v {
    width: 336px;
  }
}

@media screen and (max-width: 425px) {
  .nHSAOhz0BDYFBogX {
    width: 336px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/StudentHome.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,6CAAuC;AACzC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;EACV,wDAA8C;AAChD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;;;;GAIG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".closedPage {\r\n  width: 1330px;\r\n  margin: 0 auto 0;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.closedPage .image {\r\n  height: 280px;\r\n  aspect-ratio: 2/1;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.closedPage .info {\r\n  width: 570px;\r\n}\r\n\r\n.closedTitle {\r\n  font-size: 42px;\r\n  color: #303030;\r\n  font-weight: 600;\r\n  margin: 0 0 22px;\r\n  font-family: Montserrat;\r\n  line-height: 106%;\r\n}\r\n\r\n.closedDescription {\r\n  margin: 0 0 80px;\r\n  font-size: 24px;\r\n  font-weight: 200;\r\n  font-style: italic;\r\n  color: #303030;\r\n}\r\n\r\n.orderStatusLink {\r\n  display: flex;\r\n  align-items: center;\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n  padding: 12px 25px;\r\n  border-radius: 16px;\r\n  font-size: 24px;\r\n  width: fit-content;\r\n  font-weight: 200;\r\n}\r\n\r\n.orderStatusLink i {\r\n  margin-right: 13px;\r\n}\r\n\r\n.orderStatusLink:hover {\r\n  color: #20336c;\r\n  background-color: #ffffff;\r\n  border: 1px solid #20336c;\r\n}\r\n\r\n.pageWrapper {\r\n  width: 1180px;\r\n  margin: 0 auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.title {\r\n  position: relative;\r\n  text-align: center;\r\n  font-family: Montserrat;\r\n  font-weight: 300;\r\n  font-size: 100px;\r\n  color: #000000;\r\n  padding: 90px 0px;\r\n  margin: 0px;\r\n  animation: titleSlide 0.6s ease-in 0s 1;\r\n}\r\n\r\n@keyframes titleSlide {\r\n  0% {\r\n    transform: translateY(-100%);\r\n  }\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.mainWrapper {\r\n  opacity: 0;\r\n  animation: fadeIn 0.6s ease-in 0.6s 1 forwards;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.description {\r\n  font-family: \"Roboto\";\r\n  font-size: 22px;\r\n  color: #000000;\r\n  font-weight: 500;\r\n  margin-top: 0;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.cardsWrapper {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 13px;\r\n}\r\n\r\n.cardWrapper {\r\n  display: inline-block;\r\n}\r\n\r\n.cardWrapper:hover {\r\n  transform: translateY(-6px);\r\n}\r\n\r\n.cardWrapper:hover .titleWrapper {\r\n  background-color: #c6d4e1;\r\n}\r\n\r\n.stationCard {\r\n  width: 225px;\r\n  height: 225px;\r\n  border-radius: 38px;\r\n  transition: all 0.3s ease-in-out;\r\n  overflow: hidden;\r\n}\r\n/* \r\n.stationCard:hover {\r\n  box-shadow: 4px 4px 0 0 #20336c;\r\n  transform: translate(-3px, -3px);\r\n} */\r\n\r\n.stationCard .image {\r\n  height: 155px;\r\n  background-color: gray;\r\n  background-size: cover;\r\n  position: relative;\r\n}\r\n\r\n.estimatedTime {\r\n  background-color: #c84014;\r\n  font-size: 14px;\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 13px;\r\n  color: white;\r\n  padding: 6px 10px;\r\n  border: 1px solid #ffffff;\r\n  border-radius: 35px;\r\n  font-family: Roboto;\r\n}\r\n\r\n.stationCard .titleWrapper {\r\n  height: 68px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-transform: uppercase;\r\n  font-size: 16px;\r\n  font-family: \"Roboto\";\r\n  background-color: #ffffff;\r\n  padding: 0 8px;\r\n  text-align: center;\r\n  line-height: 1.2;\r\n  word-break: break-word;\r\n}\r\n\r\n@media screen and (max-width: 1360px) {\r\n  .closedPage {\r\n    width: 100%;\r\n    margin: 112px 0 85px;\r\n    padding: 0 30px;\r\n    flex-direction: column-reverse;\r\n    align-items: center;\r\n  }\r\n\r\n  .closedPage .image {\r\n    height: 176px;\r\n    margin-bottom: 132px;\r\n  }\r\n\r\n  .closedPage .info {\r\n    width: 100%;\r\n  }\r\n\r\n  .closedTitle {\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    margin: 0 0 28px;\r\n    text-align: center;\r\n  }\r\n\r\n  .closedDescription {\r\n    font-size: 14px;\r\n    text-align: center;\r\n  }\r\n\r\n  .orderStatusLink {\r\n    position: absolute;\r\n    bottom: 106px;\r\n    width: calc(100% - 60px);\r\n    justify-content: center;\r\n    font-size: 16px;\r\n    padding: 17px 0px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1240px) {\r\n  .pageWrapper {\r\n    width: 688px;\r\n  }\r\n\r\n  .title {\r\n    padding: 38px 0px 22px;\r\n    font-size: 36px;\r\n  }\r\n\r\n  .description {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    margin-top: 0;\r\n    margin-bottom: 18px;\r\n  }\r\n\r\n  .cardsWrapper {\r\n    width: 688px;\r\n    margin: 0px auto;\r\n  }\r\n\r\n  .stationCard {\r\n    width: 160px;\r\n    height: 160px;\r\n    border-radius: 30px;\r\n  }\r\n\r\n  .stationCard .image {\r\n    height: 109px;\r\n  }\r\n\r\n  .estimatedTime {\r\n    font-size: 10px;\r\n    top: 9px;\r\n    right: 10px;\r\n    padding: 4px 6px;\r\n    border-radius: 35px;\r\n  }\r\n\r\n  .stationCard .titleWrapper {\r\n    height: 50px;\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .cardsWrapper {\r\n    width: 512px;\r\n  }\r\n  .pageWrapper {\r\n    width: 512px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .cardsWrapper {\r\n    width: 336px;\r\n  }\r\n  .pageWrapper {\r\n    width: 336px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 425px) {\r\n  .cardsWrapper {\r\n    width: 336px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var closedPage = `bNv2OJM5q404ji2I`;
export var image = `LDEs8UZpisEBr9zM`;
export var info = `RPvvKGW6mdciHSkb`;
export var closedTitle = `VCVH1a6uJikw4yGY`;
export var closedDescription = `JVVcciaQtwgDC8LT`;
export var orderStatusLink = `NiXWl9Y0XE040ADy`;
export var pageWrapper = `M_cvgcOOKw4akO1v`;
export var title = `kHu2rouiRMUJK3nH`;
export var titleSlide = `h_SUPNIcX7wZfhCB`;
export var mainWrapper = `w1MNn99RX4GLps4g`;
export var fadeIn = `VHliPEr9qYEGovga`;
export var description = `bq9pglCqUhw8iQwH`;
export var cardsWrapper = `nHSAOhz0BDYFBogX`;
export var cardWrapper = `F0XXXeX6818sesO4`;
export var titleWrapper = `L5R1XVRD0z8h56IG`;
export var stationCard = `Oflek4dvgeU9mQTn`;
export var estimatedTime = `mbWm5hiqW2MEcNH_`;
export default ___CSS_LOADER_EXPORT___;
